<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="Customer List">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search"
          v-model="searchVal"
          v-debounce="onSearch"
          clearable
          @clear="onSearch"
        />
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
        @sort-change="onSortChange"
      >
        <el-table-column
          prop="No"
          width="80"
          label="No."
          sortable="custom"
          align="center"
        />
        <el-table-column
          prop="SEName"
          label="Customer Name"
          min-width="160"
          sortable="custom"
        />
        <el-table-column
          prop="City"
          label="City"
          min-width="80"
          sortable="custom"
        />
        <el-table-column
          prop="hospital"
          label="Hospital / Institution"
          min-width="180"
          sortable="custom"
        />
        <el-table-column
          prop="Department"
          label="Department"
          min-width="140"
          sortable="custom"
        />
        <el-table-column
          prop="MLName"
          :label="leaderLabel"
          min-width="120"
          sortable="custom"
        />
        <el-table-column
          prop="Teamname"
          label="Team"
          min-width="130"
          sortable="custom"
        />
        <el-table-column
          prop="Certified"
          width="110"
          label="Certified"
          sortable="custom"
        >
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParser(row.Active)" effect="dark">
              {{ tagLabelParser(row.Active) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Operation"
          width="100"
          prop="StatusDesc"
          align="center"
        >
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem
                icon="iconfont icon-read"
                title="View"
                @click="$router.push(`/customer/${row.SEID}/${row.MLID}`)"
              />
              <OptionMenuItem
                icon="iconfont icon-qrcode"
                title="QR Code"
                @click="getQRCode(row)"
              />
              <OptionMenuItem v-if="row.Active == 2" icon="iconfont el-icon-s-claim" title="Resend Term"
                @click="goToResendTerm(row)" />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :pager-count="pagerCount"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <QRCodeDialog
      title="Customer"
      :visible.sync="qrcodeDialogVisible"
      :data.sync="rowData"
    />
  </div>
</template>

<script>
import QRCodeDialog from "../../se/qrcode-dialog";

export default {
  name: "My-Customer",
  components: {
    QRCodeDialog,
  },
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      qrcodeDialogVisible: false,
      rowData: null,
      qrcodeUrl: "",
      seIds: null,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    roleName() {
      return this.$store.state.userInfo.roleName;
    },
    pagerCount() {
      let clientWidth = document.body.clientWidth;
      return clientWidth <= 1024 ? 5 : 7;
    },
    leaderLabel() {
      return this.roleName === "ClinTrans" ? "Clin-trans" : this.roleName;
    },
  },
  created() {
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
      }
    });
  },
  methods: {
    tagTypeParser(flag) {
      return flag==1 ? "success" : "danger";
    },
    tagLabelParser(flag) {
      //0和2都是No
      return flag==1 ? "Yes" : "No";
    },
    goToResendTerm(row) {
      this.axios
        .post(`/se/resendTerms`, {
          seId: row.SEID,
        })
        .then(({ code, msg }) => {
          if(code  && code !== 200){
            this.$message.error(msg);
          }else{
            this.$message.success("Resend terms successfully");
            this.getTableData();
          }
        })
        .catch(() => {
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      };
      this.axios
        .get(`/customer/getCustomerList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.multipleSelection = [];
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    getQRCode(row) {
      this.rowData = row;
      this.qrcodeDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrap {
  display: flex;
  justify-content: flex-end;

  .actions {
    display: flex;
  }

  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}
</style>
